<template>
  <div class="type-heading-lg"><slot></slot></div>
</template>
